import axios from '@/plugins/axios'

export default {
  async PAYMENT_METHODS ({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
      const data = {
        headers: {
          Authorization: 'Bearer ' + state.access_token
        }
      }
      commit('loading')
      axios.get('/settings/payment', data)
        .then((response) => {
          commit('loading')
          resolve(response)
        })
        .catch((error) => {
          commit('loading')
          reject(error)
        })
    })
  },
  async SAVE_TOKEN ({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
      const options = {
        headers: {
          Authorization: 'Bearer ' + state.access_token
        }
      }
      commit('loading')
      axios.post('/settings/payment/' + payload.intermediary, payload, options)
        .then((response) => {
          commit('loading')
          resolve(response)
        }).catch((error) => {
          commit('loading')
          reject(error)
        })
    })
  },
  async KEYS_INTERMEDIARY ({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
      const data = {
        headers: {
          Authorization: 'Bearer ' + state.access_token
        }
      }
      commit('loading')
      axios.get('/settings/payment/' + payload, data)
        .then((response) => {
          commit('loading')
          resolve(response)
        })
        .catch((error) => {
          commit('loading')
          reject(error)
        })
    })
  }
}
